import styled from 'styled-components';

const HorizontalView = styled.div`
  display: flex;
  align-items: center;
`;

const VerticalView = styled.div`
  display: flex;
  flex-direction: column;
  justify-items: center;
`;

export { HorizontalView, VerticalView };
